import useAuth from "../../utils/CustomHooks/useAuth/useAuth";

/**
 * Creates trigger function to invalidate bol
 * @param {string} cargoCaseDocId
 * @returns {(id : string) => (() => void)}
 */

export function useInvalidateBol(cargoCaseDocId) {
  const { getRequestDataToggle, getIdUpdateBol, getIdCreateDoc } = useAuth();

  return (id) => () => {
    getRequestDataToggle();

    if (cargoCaseDocId !== undefined) {
      getIdCreateDoc(cargoCaseDocId)
      getIdUpdateBol(id)
    } else getIdUpdateBol(id);
  };
}

/**
 * Creates trigger function to invalidate man
 * @param {string} cargoCaseDocId
 * @returns {(id : string) => (() => void)}
 */

export function useInvalidateMan(cargoCaseDocId) {
  const { getRequestDataToggle, getIdUpdateMan, getIdCreateDoc } = useAuth();

  return (id) => () => {
    getRequestDataToggle();

    if (cargoCaseDocId !== undefined) {
      getIdCreateDoc(cargoCaseDocId)
      getIdUpdateMan(id)
    }
    else getIdUpdateMan(id);
  };
}
